import { createRouter, createWebHistory } from "vue-router";
import Litigations from "../components/Litigations.vue";
import HomeComponent from "../components/HomeComponent.vue";

const initRouter = () => createRouter({
  history: createWebHistory("/"),
  routes: [
     {
      path: '/',
      name: 'HomeComponent',
      component: HomeComponent
    },
    {
      path: "/litigations",
      name: "Contenziosi",
      component: Litigations
    },
  ],
});

export { initRouter };